import Api from "api/widget.api";
import {API} from "utils/api";

export const serviceWidgetUpdateAction = async (id, action = 'is_active') => {
    const res = await API.post(Api.postAction.replace(':id', id), {action});
    return !!res;
}

export const serviceWidgetDestroy = async (id) => {
    const res = await API.delete(Api.deleteDestroy.replace(':id', id));
    return !!res;
}

export const serviceWidgetSave = async (data) => {
    try {
        let res = '';
        if (data?.id) res = await API.put(Api.putUpdate.replace(':id', data.id), data)
        else res = await API.post(Api.postCreate, data)

        return !!res;
    } catch (e) {
        return false
    }
}

export const serviceWidgetItem = async (id) => {
    const res = await API.get(Api.getId.replace(':id', id))
    if (res) return res;
    return false;
}
